import { IconProps } from '@/types/icon';

export const TelegramIconOutline = ({
  width = 24,
  height = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.82073 5.60466L16.3807 2.41802C20.6708 0.987968 23.0017 3.33009 21.5829 7.62024L18.3962 17.1802C16.2568 23.6098 12.7436 23.6098 10.6042 17.1802L9.6583 14.3426L6.82073 13.3967C0.391139 11.2573 0.391139 7.75536 6.82073 5.60466Z"
        stroke="#469D18"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.87207 13.9125L13.9121 9.87012"
        stroke="#469D18"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
